import React from 'react';
import PropTypes from 'prop-types'

export default function AlertFill({fill})
{
	return (
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="10 10 100 99" xmlSpace="preserve" fill={fill}>
			<path d="M87.4,74.8L55.7,19.9c-1.7-2.9-5.8-2.9-7.4,0L16.6,74.8c-1.7,2.9,0.4,6.4,3.7,6.4h63.4C87,81.2,89.1,77.7,87.4,74.8z
		M52,72.2c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3C56.3,70.3,54.4,72.2,52,72.2z M56.5,54.7h-9V36.9h9V54.7z"
			/>
		</svg>
	)
}

AlertFill.propTypes = {
  fill: PropTypes.string
};